import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Checkbox,
  Spin,
  Select,
  Button,
} from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const GLA1100 = (props) => {
  const columns = [
    {
      title: "Created By",
      dataIndex: "createdUser",
    },
    {
      title: "Created On",
      dataIndex: "createdDate",
    },
    {
      title: "Journal Entry Created",
      dataIndex: "journalEntry",
      render: (text) => {
        return (
          <Checkbox
            disabled
            checked={text}
            style={{ color: text ? "green" : "red" }}
          />
        );
      },
    },
    {
      title: "View Journal Entries",
      dataIndex: "journalEntry",
      align: "center",
      render: (text, record) => {
        return (
          <Button
            type="primary"
            disabled={!text}
            onClick={() => handleOnViewJounalEntries(record)}
            icon={<EyeOutlined />}
            style={{
              backgroundColor: text ? "#92428B" : "#F5F5F5",
              border: "none",
              color: text ? "#fff" : "#C0C0C0",
              fontWeight: text ? "normal" : "bolder",
              width: "10vh",
            }}
          >
            View
          </Button>
        );
      },
    },
  ];

  const csvColumns = [
    {
      title: "Created By",
      dataIndex: "createdUser",
    },
    {
      title: "Created On",
      dataIndex: "createdDate",
    },
    {
      title: "Journal Entry Created",
      dataIndex: "journalEntry",
      render: (text) => {
        return (
          <Checkbox
            disabled
            checked={text}
            style={{ color: text ? "green" : "red" }}
          />
        );
      },
    },
  ];

  const { userData, rightBtn, rightAction } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [provisioningEntryList, setProvisioningEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setProvisioningEntryList(originalList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter((item) =>
      item?.createdUser?.includes(searchKey.toLowerCase())
    );
    // console.log(filterBySearch);
    setProvisioningEntryList(filterBySearch);
  }

  function handleOnViewJounalEntries(record) {
    if (!record) {
      console.log("No record selected");
      return;
    }
    navigate("/journal-gla1100", { state: record });
  }

  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    getProvisioningEntriesAction();
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    BOM.HasPermission("VIEW_ALL_PROVISIONING_ENTRIES") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getProvisioningEntriesAction = () => {
    const params = {
      sortOrder: "DESC",
      orderBy: "createdDate",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, definedApi.GetProvisioningEntries, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            createdUser: element?.createdUser ? element?.createdUser : "-",
            createdDate: element?.createdDate
              ? `${element?.createdDate[2]} ${
                  monthList[element?.createdDate[1] - 1]
                } ${element?.createdDate[0]}`
              : "-",
            modifiedById: element?.modifiedById ? element?.modifiedById : "-",
            createdById: element?.createdById ? element?.createdById : "-",
            journalEntry: element?.journalEntry,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setProvisioningEntryList(tempArray.filter((item) => item.disabled === false));
        setProvisioningEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        sortOrder: "DESC",
        orderBy: "createdDate",
      };

      let body = {
        session,
        params,
      };

      const apiUrl = "provisioningentries?dateFormat=dd+MMMM+yyyy&locale=en";

      BOM.FetchReqAction(body, BOM.baseUrl(apiUrl), (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id ? element?.id : "-",
              createdUser: element?.createdUser ? element?.createdUser : "-",
              createdDate: element?.createdDate
                ? `${element?.createdDate[2]} ${
                    monthList[element?.createdDate[1] - 1]
                  } ${element?.createdDate[0]}`
                : "-",
              modifiedById: element?.modifiedById ? element?.modifiedById : "-",
              createdById: element?.createdById ? element?.createdById : "-",
              journalEntry: element?.journalEntry ? "Yes" : "No",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla1100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla1100", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
    >
      <TopContent
        pageTitle={appLabel.provisioningEntries}
        pageItems={appStatic.provisioningEntriesItems}
      />

      <Card
        title={`${appLabel.provisioningEntries} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>
            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by User..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={provisioningEntryList}
              columns={csvColumns}
              fileName={"Provisioning Entries List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={provisioningEntryList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA1100);
